module.exports = __webpack_public_path__ + "img/colombia.d4e2f501.svg";